import cx from 'classnames'
import type { ReactNode } from 'react'

import { paperStyles } from '../libs/paperStyles'

export const MarkdownCode = ({ children }: { children?: ReactNode }) => (
  <code
    className={cx(
      'font-mono wrap-break-word text-wrap text-base! rounded-md p-1 inline-block',
      paperStyles({ isFaded: true, borders: ['all'] }),
    )}
  >
    {children}
  </code>
)
